<template>
  <div class="footer">
    <div class="footer-row container">
      <div class="footer-top">
        <div class="footer-top-left" data-aos="fade-left" :data-aos-duration="1500">
          <h1>恩莱吉能源科技</h1>
          <span>Energy Science and Technology</span>
          <table style="color: #E6E6E6; line-height: 30px; margin: auto; margin-top: 20px; color: #8C8C8C;">
            <tr v-for="item in contactList" :key="item.id">
              <td>{{item.simpleTitle+'联系电话：'}}</td>
              <td>{{item.telephone}}</td>
            </tr>
          </table>
        </div>
        <div class="footer-top-right" data-aos="fade-right" :data-aos-duration="1500">
          <ul class="footer-nav">
            <li v-for="nav in navData" :key="nav.id" class="nav-item" @mouseenter="activeNav = nav">
              <p @click="anchorJump(nav)">{{ nav.name }}</p>
              <ul class="footer-sub-nav">
                <li v-for="subNav in nav.subNavData" :key="subNav.id + subNav.anchorId" class="sub-nav-item"
                    @click="anchorJump(subNav)">
                  {{ subNav.name }}
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer-bottom">
        <p>
          Copyright © 恩莱吉能源科技 All Rights Reserved |
          <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2023029129号</a> |
          <img src="@/assets/images/备案图标.png" alt="" style="position: relative; top: 5px;">
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030602007577" target="_blank"> 粤公网安备 44030602007577号</a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "Footer",
  data() {
    return {
      activeNav: {},
      navData: [
        {
          id: 1,
          name: '关于我们',
          toPath: '/about',
          subNavData: [
            {id: 1, name: '公司简介', anchorId: 'about-introduce'},
            {id: 2, name: '董事长寄语', anchorId: 'about-bossMessage'},
            {id: 3, name: '文化理念', anchorId: 'about-cultural'},
            {id: 4, name: '核心业务', anchorId: 'about-business'},
            {id: 4, name: '联系我们', anchorId: 'about-contact'},
          ]
        },
        {
          id: 2,
          name: '工程业绩',
          toPath: '/project',
          subNavData: [
            {id: 1, name: '代表工程', anchorId: 'project-deputy'},
            {id: 2, name: '主要工程', anchorId: 'project-main'},
            {id: 3, name: '专题', anchorId: 'project-special-subject'},
          ]
        },
        {
          id: 3,
          name: '专利证书',
          toPath: '/certificate',
          subNavData: [
            {id: 1, name: '发明专利', anchorId: 'certificate-invent'},
            {id: 2, name: '计算机软件著作权', anchorId: 'certificate-software'},
            {id: 3, name: '实用新型专利', anchorId: 'certificate-practical'},
            {id: 4, name: '资质证书', anchorId: 'certificate-qualification'},
          ]
        },
      ],
    }
  },
  computed: {
    ...mapState('about', ['contactList'])
  },
  methods: {
    // 锚跳
    anchorJump(anchorItem) {
      const anchorId = anchorItem.anchorId
      const toPath = this.activeNav.toPath
      if (toPath && toPath !== this.$route.path) {
        this.$router.push({path: toPath, name: toPath.replace('/', ''), params: {anchorItem}})
      } else {
        if (anchorId) {
          if (anchorId.indexOf('certificate') !== -1) {
            this.$bus.$emit("goAnchorModel", anchorItem)
          } else {
            this.$nextTick(() => {
              this.$bus.$emit("goAnchor", anchorId)
            })
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="less">
.footer {
  padding-top: 75px;
  min-height: 340px;
  background-color: #1f1f1f;

  .footer-row {

    .footer-top {
      display: flex;
      justify-content: left;

      .footer-top-left {
        margin: 0 300px 0 80px;

        h1 {
          font-size: 32px;
          color: #E6E6E6;
        }

        span {
          font-size: 15px;
          color: #E6E6E6;
        }
      }

      .footer-top-right {
        color: #E6E6E6;

        .footer-nav {
          display: flex;
          justify-content: space-between;

          .nav-item {
            margin-right: 80px;

            p {
              margin-bottom: 10px;
              font-size: 16px;
            }

            .sub-nav-item {
              line-height: 30px;
              color: #8C8C8C;

              &:hover {
                cursor: pointer;
                text-decoration: underline;
              }
            }
          }
        }
      }
    }
  }

  .footer-bottom {
    padding-top: 10px;
    margin-top: 60px;
    border-top: 1px solid #8C8C8C;
    text-align: center;
    color: #E6E6E6;
    font-size: 15px;

    a {
      color: #E6E6E6;
      line-height: 80px;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  //.footer-row {
  //  padding: 22px 0;
  //  color: white;
  //  font-size: 15px;
  //  line-height: 25px;
  //  text-align: center;
  //
  //  table {
  //    margin: auto;
  //    //text-align: left;
  //
  //    tr {
  //
  //      td {
  //        padding:2.5px 20px;
  //
  //      }
  //    }
  //  }
  //
  //  a {
  //    color: white;
  //
  //    &:hover {
  //
  //      text-decoration: underline;
  //    }
  //  }
  //}
}
</style>